export default __webpack_public_path__ + "static/media/services.755393fb.PNG";